/**
 * @generated SignedSource<<1236c9a271314d8a12de988e611e0698>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PixAutomaticApprovedInput = {
  clientSubscriptionId?: string | null | undefined;
  paymentSubscriptionId?: string | null | undefined;
};
export type PixAutomaticApprovedSubscription$variables = {
  input: PixAutomaticApprovedInput;
};
export type PixAutomaticApprovedSubscription$data = {
  readonly PixAutomaticApproved: {
    readonly paymentSubscription: {
      readonly id: string;
      readonly isActive: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PixAutomaticApprovedSubscription = {
  response: PixAutomaticApprovedSubscription$data;
  variables: PixAutomaticApprovedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PixAutomaticApprovedPayload",
    "kind": "LinkedField",
    "name": "PixAutomaticApproved",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentSubscription",
        "kind": "LinkedField",
        "name": "paymentSubscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PixAutomaticApprovedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PixAutomaticApprovedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3c157712f781cd64a4931316101cef64",
    "id": null,
    "metadata": {},
    "name": "PixAutomaticApprovedSubscription",
    "operationKind": "subscription",
    "text": "subscription PixAutomaticApprovedSubscription(\n  $input: PixAutomaticApprovedInput!\n) {\n  PixAutomaticApproved(input: $input) {\n    paymentSubscription {\n      id\n      isActive\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41e44a1a5d627adcb398400cc3d46bd0";

export default node;
